export function get(obj, path, defaultValue) {
    const result = path.split('.').reduce((r, p) => {
        if (typeof r === 'object') {
            p = p.startsWith('[') ? p.replace(/\D/g, '') : p;
            return r[p];
        }
        return undefined;
    }, obj);
    return result !== undefined ? result : defaultValue;
}
export function prune(obj) {
    Object.keys(obj).forEach((key) => {
        const value = obj[key];
        const hasProperties = value && Object.keys(value).length > 0;
        if (value === null) {
            delete obj[key];
        }
        else if (typeof value !== 'string' && hasProperties) {
            prune(value);
        }
    });
    return obj;
}
export const beautify = (obj) => {
    for (const [k, v] of Object.entries(obj)) {
        if (Object(v) === v)
            beautify(v);
        else if (typeof v === 'string')
            obj[k] = v.trim();
    }
    return obj;
};
//# sourceMappingURL=object.js.map